import React, { useEffect } from 'react';
import axios from 'axios';
import { navigate } from '@reach/router';
import { useSession } from 'app/hooks/useSession';
import toast from 'react-hot-toast';

function LoginCallback(props) {
  const { session, setSession, sanitizeResponse, setUserData, signOut, storeSsoToken, storeConnections, storeDBNumber } = useSession();

  useEffect(() => {
    const authenticateUser = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const token = urlSearchParams.get('token');
      const dbNumber = urlSearchParams.get('db_number');
      const url = process.env.REACT_APP_SSO_API_URL;

      if (token && dbNumber) {
        const data = {
          token,
          db_number: parseInt(dbNumber)
        };

        try {
          const api = axios.create({
            baseURL: url
          });
          const response = await api.post(`api/v1/authenticate-token`, data);
          storeSsoToken(response.data.token);
          storeConnections(response.data.connections);
          storeDBNumber(dbNumber);
          const newObject = sanitizeResponse(response.data.session.data.attributes);
          setSession({ user: newObject });
          navigate('/');
        } catch (e) {
          if (e.response.status === 401) {
            signOut();
          } else {
            toast.error(e.message);
          }
        }
      } else {
        toast.error('Formato de URL inválido');
      }
    };

    const authEtipiUser = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const token = urlSearchParams.get('token');
      const url = process.env.REACT_APP_PRODUCTION_URL;

      if (token) {
        try {
          const response = await axios.get(`${url}/session-callback?token=${token}`);
          const newObject = sanitizeResponse(response.data.data.attributes);
          newObject.authToken = response.data.data.attributes['auth-token'];
          newObject.profileNames = response.data.data.attributes['profile-names'] || [];
          newObject.tokenExpirationDate = response.data.data.attributes['token-expiration-date'];
          delete newObject['auth-token'];
          delete newObject['profile-names'];
          delete newObject['token-expiration-date'];
          setSession({ user: newObject });
          console.log('newObject', newObject);
          navigate(process.env.REACT_APP_BASE_PATH || '/');
        } catch (e) {
          console.log('error', e);
          return;
          if (e) {
            signOut();
          } else {
            toast.error(e.message);
            navigate(process.env.REACT_APP_BASE_PATH || '/');
          }
        }
      } else {
        toast.error('Formato de URL inválido');
      }
    };

    const ssoEtipi = process.env.REACT_APP_ETIPI_SSO_API_URL;
    if (ssoEtipi) {
      authEtipiUser();
    } else {
      authenticateUser();
    }
  }, []);

  return <div className="new-login"></div>;
}

export default LoginCallback;
